import React, { useState } from 'react';
import './boss-shared-Notification.scss';

function BossSharedNotification({
	pickupDetails,
	fulfillmentDetails={},
	handleToggle,
	needMoreShown,
	selectedOption,
}) {
	const [qtyErrorHide, toggleQtyErrorHide] = useState(false);
	let { type, bossDominant} = pickupDetails;
	let { storeName, isBossBopisSharedTile} = fulfillmentDetails;
	const storeNameText = storeName ?
		<span className="u__bold">{` ${storeName} `}</span> :
		'your preferred store';

	const checkNearByStoresLink =
		<a href="#" className="u__default-link store-inventory-finder-trigger" onClick={(needMoreShown && handleToggle)}>
			Check Nearby Stores
		</a>;


	const needMoreMessageBox = (selectedOption === "PICKUP") && (pickupDetails.type === "BOPIS") &&
		<div className="ToolTip BossSharedToolTip Tooltip--need-more-products  ToolTip--bottom">
			{type === "BOPIS" &&
				<div className="ToolTip__arrow Tooltip--need-more-products Tooltip__arrow--need-more-products ToolTip__arrow--bottom BossSharedToolTip__arrow--bottom"/>
			}
			<div className="ToolTip__wrapper BossSharedToolTip__wrapper ToolTip--medium Tooltip--need-more-products ToolTip__wrapper--bottom">
				<div className="ToolTip__closebutton" onClick={ (needMoreShown && handleToggle)} />
				<div className="ToolTip__content BossSharedToolTip__content ToolTip__content--bottom">
					<div id="need-more-products-tooltip">
						<span className="u__clearfix">
							<div className="u__bold" id="need-more-text-message">
								Need More? We can ship it to your store!
							</div>
							<div>
								Just enter the quantity you need, and we will ship it to
								{storeNameText}
								for free pickup.
							</div>
							<br />
							<span className="u__bold">Need it sooner? </span>
							{checkNearByStoresLink}
							<span>
								{" to see if another store has enough items in stock. You can also split your order across multiple stores."}
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>;

	return (
		needMoreShown 
		&& bossDominant 
		&& isBossBopisSharedTile 
		&& (selectedOption === "PICKUP") 
		&& (pickupDetails.type === "BOPIS")) ?
		<div className="heading-message store_pickup_section">
			{needMoreMessageBox}
		</div> : null;
}

export default BossSharedNotification;
